import { AxiosInstance } from 'axios';
import {
  CertificateInterface,
  CertificatesRepositoryInterface,
  CreateCertificateInterface,
} from '@/services/SSL/interfaces';

export default class CertificateRepository implements CertificatesRepositoryInterface {
  constructor(
    private axios: AxiosInstance,
  ) {
  }

  public async createCertificate(data: CreateCertificateInterface): Promise<CertificateInterface> {
    const response = await this.axios.post('/ssl-controller/certificate', data);

    return response.data;
  }

  public async deleteCertificate(websiteId: number): Promise<void> {
    await this.axios.delete(`/ssl-controller/certificate/${websiteId}`);
  }

  public async getCertificate(domain: string): Promise<CertificateInterface> {
    const response = await this.axios.get(`/ssl-controller/certificate/${domain}`);

    return response.data;
  }

  public async getCertificateById(id: number): Promise<CertificateInterface> {
    const response = await this.axios.get(`/ssl-controller/certificates/${id}`);

    return response.data;
  }

  public async searchCertificates(page: number, domain: string): Promise<CertificateInterface[]> {
    if (!page || page < 1) {
      page = 1;
    }

    const response = await this.axios.get(`/ssl-controller/certificate?page=${page}&search=${domain}`);

    return response.data;
  }

  public async renewCertificate(id: number): Promise<string> {
    const response = await this.axios.patch(`/ssl-controller/certificate/${id}`);

    return response.data;
  }

  public async registerCustomCertificate(
    websiteId: number,
    certificate: string,
    key: string,
    ca: string,
  ): Promise<void> {
    await this.axios.post(`/ssl-controller/certificate/custom`, { websiteId, certificate, key, ca });
  }

  public async createSelfSignedCertificate(
    websiteId: number,
    altNames: string[],
    autoRenew: boolean,
    vhostAliases: boolean,
    email?: string,
  ): Promise<void> {
    await this.axios.post(`/ssl-controller/certificate/self-signed`, {
      websiteId,
      altNames,
      email,
      autoRenew,
      vhostAliases,
    });
  }


  public async createLestEncryptCertificate(
    websiteId: number,
    subDomains: string[],
    autoRenew: boolean,
    vhostAliases: boolean,
    email?: string,
  ): Promise<void> {
    await this.axios.post(`/ssl-controller/certificate/lets-encrypt`, {
      websiteId,
      subDomains,
      email,
      autoRenew,
      vhostAliases,
    });
  }
}
